import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../shared/tooltip/Tooltip';
import './Tabs.css';

class Tabs extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            selected: 0,
        };
    }

    getInitialState() {
        return {
            selected: this.props.selected
        };
    }
    handleClick(index) {
        this.setState({
            selected: index
        });
    }

    copyScript() {
        var script = document.getElementsByClassName('tab-pane')[0].innerText;
        const textArea = document.createElement('textarea');
        textArea.textContent = script;
        document.body.append(textArea);
        textArea.select();
        document.execCommand("copy");
        this.tooltip.showTooltip();
        textArea.remove();
    }

    renderTitles() {
        function labels(child, index) {
            let activeClass = (this.state.selected === index ? 'tab-item active' : 'tab-item');
            return (
                <li key={index} className={activeClass} onClick={this.handleClick.bind(this, index)}>
                    <a>
                        {child.props.label}
                    </a>
                </li>
            );
        }
        const copyIcon = process.env.BASE_URL + "images/app/copy.png";
        return (
            <div className="tabs-wrap">
                <ul className="tab-header">
                    {this.props.children.map(labels.bind(this))}
                </ul>
                <div className="tab-copy-wrap">
                <img title="Copy" src={copyIcon} onClick={this.copyScript.bind(this)} className="tab-copy"/>
                <Tooltip message={'Copied to Clipboard!'} ref={instance => { this.tooltip = instance; }}></Tooltip>              
                </div>
            </div>
        );
    }
    renderContent() {
        return (
            <div className="tabs-wrap tab-pane">
                {this.props.children[this.state.selected]}
            </div>
        );
    }
    render() {
        return (
            <div>
                {this.renderTitles()}
                {this.renderContent()}
            </div>
        );
    }
}

Tabs.propTypes = {
    selected: PropTypes.number,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element
    ]).isRequired
}

export default Tabs;